import React from 'react'
import Container from '@material-ui/core/Container';
import imgHero from '../../assets/imghero2.jpg';
import imgcasazen from '../../assets/galeriacz2.jpg';
import namaste from '../../assets/namaste.svg';
import casazen from '../../assets/casazen.svg';
import BotonBox from '../BotonBox';


const Section5 = () => {
  return (
    <div id='rel' className='section noPadBot indexSec'>
        <Container className='relative flex flexCol'>
        <h2 className='textCenter' style={{margin: '30px 0 60px'}}>Ver más proyectos</h2>

        <div className="flex flexRow flexWrap col50 reverse">
            <div className='backDark shadow hoverScale'>
              <img className='logoBox' src={namaste} alt="Logo Namasté" />
              <h3 className='textCenter'>Entre Médanos y Mar</h3>
              <p className='textCenter relative pbox'>Una propuesta única frente al mar y en un marco natural único, con todo el confort de un proyecto pensado para una verdadera inmersión sensorial</p>
              <BotonBox className='hoverScale' text='Ver más' link='/namaste' />
            </div>
            <div>
            <img className='imgProyecto' src={imgHero} alt="Imágen Namasté" />

            </div>
          </div>

          
          <div className="flex flexRow flexWrap col50 margtop">
            <div className='backDark shadow hoverScale'>
             <img className='logoBox' src={casazen} alt="Logo Casa Zen" />
              <h3 className='textCenter relative'>Conecta los sentidos</h3>
              <p className='textCenter relative pbox'>Un proyecto cuyo patio central como protagonista aporta a la vivienda gran luminosidad a cada uno de sus espacios, consagrando junto a su fondo vidriado un estrecho vínculo con el exterior</p>
              
              <BotonBox className='hoverScale' text='Ver más' link='/casazen' />
            </div>
            <div>
              <img className='imgProyecto' src={imgcasazen} alt="Imágen Casa Zen" />
            </div>
          </div>
        </Container>
    </div>
  )
}

export default Section5